import { tokens } from "../theme";

export const planData = [
  {
    id: 1,
    offerPrice: 34,
    realPrice: 50,
    desc: "test",
    planName: "2bhk skitchen shifting",
    planImage: "",
  },
  {
    id: 2,
    offerPrice: 34,
    realPrice: 50,
    desc: "test",
    planName: "2bhk skitchen shifting",
    planImage: "",
  },
  {
    id: 3,
    offerPrice: 34,
    realPrice: 50,
    desc: "test",
    planName: "2bhk skitchen shifting",
    planImage: "",
  },
];

export const mockDataInvoices = [
  {
    id: 1,
    category: "Bed room",
    QID: "3894",
    QDate: "7/30/2024",
    name: "Jon Snow",
    contact: "9902995376",
    address:
      "#195,GF-B, Block B, 6th main, Bikasipura , Bangalore, Mango Garden Layout, Bikasipura, Bengaluru, Karnataka 560078",
    city: "",
    service: "Shift 2bhk flat",
    amount: "15000",
    Executive: "Pankaj",
    lastFDate: "5/30/2024",
    NextFDate: "8/30/2024",
    desc: "",
  },
  {
    id: 2,
    category: "Living room",
    QID: "3894",
    QDate: "7/30/2024",
    name: "Jon Snow",
    contact: "9902995376",
    address:
      "#195,GF-B, Block B, 6th main, Bikasipura , Bangalore, Mango Garden Layout, Bikasipura, Bengaluru, Karnataka 560078",
    city: "",
    service: "Shift 2bhk flat",
    amount: "15000",
    Executive: "Pankaj",
    lastFDate: "5/30/2024",
    NextFDate: "8/30/2024",
    desc: "",
  },
];

export const enquiryData = [
  {
    id: 1,
    EnquiryID: 64845,
    category: "Living room",
    customername: "jonsnow@gmail.com",
    cost: "21.24",
    contact: "9902995376",
    Enquirydate: "03/12/2024",
    address: "Sreenivas Nagar, Nandini Layout, Bengaluru, Karnataka 560058",
    city: "Bengaluru",
    Executive: "Maria",
  },
];
export const mockDataOrder = [
  {
    id: 1,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    cost: "21.24",
    phone: "(665)121-5454",
    FromDate: "07/31/2024",
    ToDate: "07/31/2024",
    pickuplocation:
      "W95W+Q7V, Tavarekere, Dodda Aladmara Road, Uttarahalli Hobli, Bengaluru, Karnataka 562130",
    droplocation:
      "W95W+Q7V, Tavarekere, Dodda Aladmara Road, Uttarahalli Hobli, Bengaluru, Karnataka 562130",
    vendor: {
      Id: "",
      vendorname: "Hema Mane",
    },
    Excutive: "Pankaj",
    Services: {
      id: 3,
      offerPrice: 34,
      realPrice: 50,
      desc: "test",
      planName: "2bhk skitchen shifting",
      planImage:
        "https://vrlmoverpacker.co/wp-content/uploads/2021/05/609fd19515d15.jpg",
    },
    referenceCode: "VHS783",
    totalAmount: 4000,
    bookingAmount: 200,
    slot: {
      id: 2,
      endTime: "2PM",
      startTime: "4PM",
    },
  },
  {
    id: 2,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    cost: "21.24",
    phone: "(665)121-5454",
    FromDate: "07/31/2024",
    ToDate: "07/31/2024",
    pickuplocation:
      "W95W+Q7V, Tavarekere, Dodda Aladmara Road, Uttarahalli Hobli, Bengaluru, Karnataka 562130",
    droplocation:
      "W95W+Q7V, Tavarekere, Dodda Aladmara Road, Uttarahalli Hobli, Bengaluru, Karnataka 562130",
    vendor: {
      Id: "",
      vendorname: "Hema Mane",
    },
    Excutive: "Pankaj",
    Services: {
      id: 3,
      offerPrice: 34,
      realPrice: 50,
      desc: "test",
      planName: "2bhk skitchen shifting",
      planImage:
        "https://vrlmoverpacker.co/wp-content/uploads/2021/05/609fd19515d15.jpg",
    },
    referenceCode: "VHS783",
    totalAmount: 4000,
    bookingAmount: 200,
    slot: {
      id: 2,
      endTime: "11PM",
      startTime: "12PM",
    },
  },
  {
    id: 3,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    cost: "21.24",
    phone: "(665)121-5454",
    FromDate: "07/13/2024",
    ToDate: "07/13/2024",
    pickuplocation:
      "W95W+Q7V, Tavarekere, Dodda Aladmara Road, Uttarahalli Hobli, Bengaluru, Karnataka 562130",
    droplocation:
      "W95W+Q7V, Tavarekere, Dodda Aladmara Road, Uttarahalli Hobli, Bengaluru, Karnataka 562130",
    vendor: {
      Id: "",
      vendorname: "Hema Mane",
    },
    Excutive: "Pankaj",
    Services: {
      id: 3,
      offerPrice: 34,
      realPrice: 50,
      desc: "test",
      planName: "2bhk skitchen shifting",
      planImage:
        "https://vrlmoverpacker.co/wp-content/uploads/2021/05/609fd19515d15.jpg",
    },
    referenceCode: "VHS783",
    totalAmount: 4000,
    bookingAmount: 200,
    slot: {
      id: 2,
      endTime: "2PM",
      startTime: "4PM",
    },
  },
];
export const mockTransactions = [
  {
    txId: "01e4dsa",
    user: "aberdohnny",
    date: "2021-09-01",
    cost: "43.95",
  },
  {
    txId: "51034szv",
    user: "goodmanave",
    date: "2022-11-05",
    cost: "200.95",
  },
  {
    txId: "0a123sb",
    user: "stevebower",
    date: "2022-11-02",
    cost: "13.55",
  },
  {
    txId: "01e4dsa",
    user: "aberdohnny",
    date: "2021-09-01",
    cost: "43.95",
  },
  {
    txId: "120s51a",
    user: "wootzifer",
    date: "2019-04-15",
    cost: "24.20",
  },
  {
    txId: "0315dsaa",
    user: "jackdower",
    date: "2022-04-01",
    cost: "133.45",
  },
];

export const mockBarData = [
  {
    country: "AG",
    "hot dog": 133,
    "hot dogColor": "hsl(257, 70%, 50%)",
    burger: 52,
    burgerColor: "hsl(326, 70%, 50%)",
    kebab: 43,
    kebabColor: "hsl(110, 70%, 50%)",
    donut: 83,
    donutColor: "hsl(9, 70%, 50%)",
  },
  {
    country: "AI",
    "hot dog": 81,
    "hot dogColor": "hsl(190, 70%, 50%)",
    burger: 80,
    burgerColor: "hsl(325, 70%, 50%)",
    kebab: 112,
    kebabColor: "hsl(54, 70%, 50%)",
    donut: 35,
    donutColor: "hsl(285, 70%, 50%)",
  },
  {
    country: "AL",
    "hot dog": 66,
    "hot dogColor": "hsl(208, 70%, 50%)",
    burger: 111,
    burgerColor: "hsl(334, 70%, 50%)",
    kebab: 167,
    kebabColor: "hsl(182, 70%, 50%)",
    donut: 18,
    donutColor: "hsl(76, 70%, 50%)",
  },
  {
    country: "AM",
    "hot dog": 80,
    "hot dogColor": "hsl(87, 70%, 50%)",
    burger: 47,
    burgerColor: "hsl(141, 70%, 50%)",
    kebab: 158,
    kebabColor: "hsl(224, 70%, 50%)",
    donut: 49,
    donutColor: "hsl(274, 70%, 50%)",
  },
];

export const mockPieData = [
  {
    id: "hack",
    label: "hack",
    value: 239,
    color: "hsl(104, 70%, 50%)",
  },
  {
    id: "make",
    label: "make",
    value: 170,
    color: "hsl(162, 70%, 50%)",
  },
  {
    id: "go",
    label: "go",
    value: 322,
    color: "hsl(291, 70%, 50%)",
  },
  {
    id: "lisp",
    label: "lisp",
    value: 503,
    color: "hsl(229, 70%, 50%)",
  },
  {
    id: "scala",
    label: "scala",
    value: 584,
    color: "hsl(344, 70%, 50%)",
  },
];

export const mockLineData = [
  {
    id: "Karnataka",
    color: tokens("dark").greenAccent[500],
    data: [
      {
        x: "Trucks",
        y: 101,
      },
      {
        x: "2 Wheeler",
        y: 75,
      },
      {
        x: "Packers & Movers",
        y: 36,
      },
      {
        x: "All India Parcel",
        y: 216,
      },
    ],
  },
  {
    id: "Maharastra",
    color: tokens("dark").blueAccent[300],

    data: [
      {
        x: "Trucks",
        y: 212,
      },
      {
        x: "2 Wheeler",
        y: 251,
      },
      {
        x: "Packers & Movers",
        y: 87,
      },
      {
        x: "All India Parcel",
        y: 97,
      },
    ],
  },

  {
    id: "Tamil Nadu",
    color: tokens("dark").blueAccent[300],

    data: [
      {
        x: "Trucks",
        y: 240,
      },
      {
        x: "2 Wheeler",
        y: 390,
      },
      {
        x: "Packers & Movers",
        y: 40,
      },
      {
        x: "All India Parcel",
        y: 97,
      },
    ],
  },
];
